<span
  class="origin"
  cdkOverlayOrigin
  #internalOrigin="cdkOverlayOrigin"
></span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="activeOrigin"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="10"
  [cdkConnectedOverlayPositions]="overlayPositions"
  cdkConnectedOverlayPanelClass="popover-multi-select-overlay"
>
  <div
    #menuOverlay
    class="menu"
    role="menu"
  >
    <div
      class="search"
    >
      <div>
        <i class="fa-regular fa-magnifying-glass"></i>
      </div>

      <input
        #searchBox
        [placeholder]="inputPlaceholder"
        [(ngModel)]="searchTerm"
        (keyup)="onSearchInput()"
        (keyup.enter)="onEnterKey()"
      >
    </div>

    @if (loading) {
      <div class="spinner-row">
        <motn-spinner></motn-spinner>
      </div>
    }

    @if (!loading && shownOptions.length === 0) {
      <div class="empty">{{ searchTerm ? 'No results' : 'No options available' }}</div>
    }

    @if (!loading && shownOptions.length > 0) {
      <cdk-virtual-scroll-viewport
        itemSize="40"
      >
          <a
            *cdkVirtualFor="let option of shownOptions; trackBy: trackByOptionId"
            [attr.data-id]="option.id"
            [routerLink]="option.href ?? null"
            [ngClass]="{'menu-item': true, 'selected': option.selected}"
            role="menuitem"
            (click)="onClick(option)"
          >
            @if (multiOrSingle === 'multi' && option.selected) {
              <div>
                <i class="fa-solid fa-square-check"></i>
              </div>
            }

            @if (multiOrSingle === 'multi' && !option.selected) {
              <div>
                <i class="fa-solid fa-square"></i>
              </div>
            }

            <div
              class="text"
            >
              @if (option.pill) {
                <div>
                  <motn-pill [squareLetter]="option.pill.letter">{{ option.pill.text }}</motn-pill>
                </div>
              }

              <span class="option-name">{{option.name}}</span>

              @if (option.subtitle) {
                <span class="option-subtitle">{{ option.subtitle }}</span>
              }
            </div>
          </a>
      </cdk-virtual-scroll-viewport>
    }
    @if (createLabel) {
      @let isCreateDisabled = createDisabled || (createRequiresInput && !searchTerm.trim());
      <div
        class="create-option"
        [class.disabled]="isCreateDisabled"
        (click)="!isCreateDisabled && createClicked$.emit(searchTerm.trim())"
      >
        <button class="small" [disabled]="isCreateDisabled">
          {{ createLabel }}{{ searchTerm.trim() ? ' "' + searchTerm.trim() + '"' : '' }}
        </button>
      </div>
    }
  </div>
</ng-template>
